import Cookies from 'js-cookie'

const TokenKey = 'icawebsite_token'

export function getToken() {
  return Cookies.get(TokenKey)
}

export function setToken(token) {
  return Cookies.set(TokenKey, token)
}

export function removeToken() {
  return Cookies.remove(TokenKey)
}

const LanguageKey = 'icawebsite_language'

export function getLanguage() {
  return Cookies.get(LanguageKey)
}

export function setLanguage(language) {
  return Cookies.set(LanguageKey, language)
}

export function removeLanguage() {
  return Cookies.remove(LanguageKey)
}





// WEBPACK FOOTER //
// ./src/utils/auth.js